import { FeatureFlag } from '@ps/web-core-enums';
import type { TrackedTranslation } from '@ps/web-core-intl';
import { PromptTourType, useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import trScreenVideo from '../../assets/video/tr-screen-video.mp4';
import trVideoMobile from '../../assets/video/tr-video-mobile.mp4';
import Prompt from '../Prompt/Prompt';

import {
  TXTCLI_Continue_to_Cashier,
  TXTWCL_Continue_to_deposit,
  TXTWCL_Continue_to_withdraw,
  TXTWCL_Take_the_tour,
  TXTWCL_WeXve_made_some_improvements_f_ELL,
  TXTWCL_Welcome_to_the_new_Cashier_,
  TXTWCL_Welcome_to_the_new_deposit_exp_ELL,
  TXTWCL_Welcome_to_the_new_withdrawal__ELL
} from './PromptTour.messages.json';
import { usePromptTourActions } from './usePromptTourActions';

interface Props {
  flow?: PromptTourType;
  handleTourClick?: () => void;
}

const translations: Record<PromptTourType, { title: TrackedTranslation; btn: TrackedTranslation }> =
  {
    [PromptTourType.FirstDeposit]: {
      title: TXTWCL_Welcome_to_the_new_deposit_exp_ELL,
      btn: TXTWCL_Continue_to_deposit
    },
    [PromptTourType.FirstWithdraw]: {
      title: TXTWCL_Welcome_to_the_new_withdrawal__ELL,
      btn: TXTWCL_Continue_to_withdraw
    },
    [PromptTourType.Cashier]: {
      title: TXTWCL_Welcome_to_the_new_Cashier_,
      btn: TXTCLI_Continue_to_Cashier
    }
  };

const PromptTour: React.FC<Props> = ({ flow, handleTourClick }) => {
  const userSeenPrompt = useSelector(select.localSettings.getCashier)?.userSeenPrompt;
  const isMobile = useSelector(select.device.isMobile);
  const video = isMobile ? trVideoMobile : trScreenVideo;
  const updateUserTour = usePromptTourActions();
  const isSwcTurorial = useFeature(FeatureFlag.SwcTurorial);
  const showCashierTour = useSelector(select.account.showCashierTour);

  if (!flow) return null;
  if (
    !(
      [PromptTourType.FirstDeposit, PromptTourType.FirstWithdraw, PromptTourType.Cashier].includes(
        flow
      ) && showCashierTour
    ) ||
    userSeenPrompt?.[flow]
  )
    return null;

  return (
    <Prompt
      title={{
        translation: translations[flow].title
      }}
      variant="info"
      onClose={() => updateUserTour(flow)}
      primaryButton={{ translation: translations[flow]?.btn }}
      onPrimaryButtonClick={() => updateUserTour(flow)}
      secondaryButton={
        flow === PromptTourType.Cashier && isSwcTurorial
          ? { translation: TXTWCL_Take_the_tour }
          : undefined
      }
      onSecondaryButtonClick={() => {
        updateUserTour(flow);
        handleTourClick?.();
      }}
      video={video}
      isVideoTour
    >
      <Translation {...TXTWCL_WeXve_made_some_improvements_f_ELL} />
    </Prompt>
  );
};

export default PromptTour;
